import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import useConfig from "@/lib/useConfig";
import CountrySelector from "@/components/CountrySelector";

const nav = [
  { to: "/treatments", label: "Treatments" },
  { to: "/hospitals", label: "Hospitals" },
  { to: "/doctors", label: "Doctors" },
  { to: "/costs", label: "Costs" },
  { to: "/countries", label: "Countries" },
  { to: "/blog", label: "Blog" },
  { to: "/partner", label: "Partner" },
];
// mobile menu shows longer versions
const navMobile = [
  { to: "/treatments", label: "Treatments" },
  { to: "/hospitals", label: "Hospitals" },
  { to: "/doctors", label: "Doctors" },
  { to: "/costs", label: "Estimated Costs" },
  { to: "/countries", label: "Countries" },
  { to: "/blog", label: "Blog" },
  { to: "/partner", label: "Partner With Us" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { waLink } = useConfig();
  return (
    <header className="glass-strong sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center gap-4 xl:gap-6">
        <Link to="/" className="flex items-center gap-2.5 flex-shrink-0" data-testid="nav-logo">
          <img src="/medipats-logo.png" alt="MediPats" className="w-11 h-11 object-contain drop-shadow-[0_4px_16px_rgba(180,122,154,0.35)]"/>
          <span className="font-serif text-xl xl:text-2xl tracking-tight text-[#F3E9EC]">MediPats</span>
        </Link>
        <nav className="hidden xl:flex items-center gap-5 flex-1 justify-center">
          {nav.map((n) => (
            <Link key={n.to} to={n.to}
              className={`text-sm tracking-wide whitespace-nowrap transition-colors ${pathname.startsWith(n.to) ? "text-[#B47A9A]" : "text-[#F3E9EC]/70 hover:text-[#F3E9EC]"}`}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden xl:flex items-center gap-2.5 flex-shrink-0 ml-auto">
          <CountrySelector/>
          <a href={waLink()} target="_blank" rel="noreferrer" className="btn-whatsapp px-3.5 py-2 text-sm flex items-center gap-1.5" data-testid="header-whatsapp">
            <Phone className="w-4 h-4"/> WhatsApp
          </a>
          <Link to="/enquiry" className="btn-primary px-4 py-2 text-sm font-medium whitespace-nowrap" data-testid="header-enquiry-cta">
            Get Personalised Cost
          </Link>
        </div>
        <div className="xl:hidden flex items-center gap-2 ml-auto">
          <CountrySelector compact/>
          <button className="text-[#F3E9EC]" onClick={()=>setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Open menu">
            {open ? <X/> : <Menu/>}
          </button>
        </div>
      </div>
      {open && (
        <div className="xl:hidden border-t border-[#5E3A5C]/30 bg-[#00030E]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navMobile.map(n => (
              <Link key={n.to} to={n.to} onClick={()=>setOpen(false)} className="text-[#F3E9EC]/80 py-2" data-testid={`m-nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>{n.label}</Link>
            ))}
            <Link to="/enquiry" onClick={()=>setOpen(false)} className="btn-primary text-center px-5 py-3 mt-2">Get Personalised Cost</Link>
            <a href={waLink()} target="_blank" rel="noreferrer" className="btn-whatsapp text-center px-5 py-3">Chat on WhatsApp</a>
          </div>
        </div>
      )}
    </header>
  );
}
